import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    users: []
  },
  getters: {
    users(state) {
      return state.users;
    }
  },
  actions: {
    getUsers({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let usersRef = db.collection("users");
        let users = [];
        usersRef
          //.where("is_active", "==", true) -- //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              users.push(Object.assign({}, doc.data(), { userRef: doc.id }));
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_USERS", users);
        res(users);
      });
    },
    getUserById({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guide = null;
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        listingGuideRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              guide = doc.data();
              console.log("Document data:", doc.data());
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
            res(guide);
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    makeUserGuide({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            user: profile //The user information- profile data is what is saved in guide
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    makeGuideActive({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            guide: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    makeUserBlogger({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/bloggers/items")
          .doc(profile.userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            user: profile //The user information- profile data is what is saved in guide
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    makeBloggerActive({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            blogger: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    }
  },
  //synchronous
  mutations: {
    SET_USERS(state, users) {
      if (users) {
        state.users = users;
      } else {
        state.users = [];
      }
    }
  }
};
